/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
define(['jquery', 'underscore', 'assets/js/modules/View', 'assets/js/modules/widgets/elements/radio/radioView'], function(
    $,
    _,
    View,
    RadioView
) {
    return View.extend({
        className: 'btn-group btn-toggle',

        /**
         * @type {string|null}
         */
        labelClass: null,

        /**
         * @{inheritdoc}
         */
        initialize: function(options) {
            var _this = this;
            this.pricingCalcItemModel = options.pricingCalcItemModel;
            this.isButtonRows = options.isButtonRows;

            this.model.get('items').on('selected', function(item) {
                _this.onSelected(item);
            });
        },

        /**
         * @param {RadioModel} model
         */
        onSelected: function(model) {
            this.model
                .get('items')
                .findWhere({ active: true })
                .set('active', false);
            model.set('active', true);
            this.render();
        },

        /**
         * @return {object}
         */
        getItems: function() {
            return this.model.get('items').map(function(item) {
                return new RadioView({
                    model: item
                }).render().el;
            }, this);
        },

        /**
         * @return {SwitcherView}
         */
        render: function() {
            this.$el.html(this.getItems());
            var length = this.model.get('items').length;

            if (this.isButtonRows && length <= 2) {
                length = 3;
            }

            this.$el.addClass('btn-group-' + length);

            return this;
        }
    });
});
